import React from "react";
import { Formik, Form } from "formik";
import capitalize from "lodash/capitalize";
import { Alert, Modal, Row, Col } from "components/bootstrap";
import { FormikFormGroup, ModalSubmit } from "components/common";
import { getCredentialsDefinition } from "data-tiering/repository-credentials";
import useRepositories from "./hooks/useRepositories";
import useRepositoryFormErrors from "./hooks/useRepositoryFormErrors";
import { resolveRepositoryType } from "./types";
const KNOWN_FIELDS = ["name", "bucket", "container", "base_path", "credentials"];
const CloudStorageRepositoryModalForm = ({ type, hideModal }) => {
  const { onCreateRepository } = useRepositories();
  const { formError, clearFormError, applyBackendErrors } = useRepositoryFormErrors(KNOWN_FIELDS);
  const definition = getCredentialsDefinition(type);
  const CredentialFields = definition == null ? void 0 : definition.create.Fields;
  const handleSubmit = (values, { setErrors }) => {
    const { bucket, container, ...baseValues } = values;
    const submitValues = {
      type: resolveRepositoryType(type),
      ...baseValues,
      ...bucket && { bucket },
      ...container && { container }
    };
    clearFormError();
    return onCreateRepository(submitValues).then(() => hideModal()).catch((error) => applyBackendErrors(error, setErrors));
  };
  const commonValues = {
    name: "",
    base_path: ""
  };
  const bucketLabel = type === "azure" ? "container" : "bucket";
  const initialValues = {
    ...commonValues,
    [bucketLabel]: "",
    ...definition && { credentials: definition.create.initialValues() }
  };
  const validate = (values) => {
    var _a, _b, _c;
    const errors = {};
    if (!((_a = values.name) == null ? void 0 : _a.trim())) errors.name = "Name is required.";
    if (!((_b = values[bucketLabel]) == null ? void 0 : _b.trim())) errors[bucketLabel] = `${capitalize(bucketLabel)} is required.`;
    if (!((_c = values.base_path) == null ? void 0 : _c.trim())) errors.base_path = "Base Path is required.";
    if (definition) {
      const credentialErrors = definition.create.validate(values.credentials);
      if (Object.keys(credentialErrors).length > 0) errors.credentials = credentialErrors;
    }
    return errors;
  };
  return /* @__PURE__ */ React.createElement(
    Formik,
    {
      onSubmit: handleSubmit,
      initialValues,
      validate,
      validateOnMount: true
    },
    ({ isSubmitting, isValidating, isValid }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Body, null, formError && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, formError), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        type: "text",
        label: "Name",
        name: "name",
        help: "Name of your warm storage repository. Must be unique.",
        required: true
      }
    ), /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        type: "text",
        label: capitalize(bucketLabel),
        name: bucketLabel,
        help: `Name the warm storage repository ${bucketLabel}`,
        required: true
      }
    ), /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        type: "text",
        label: "Base Path",
        name: "base_path",
        help: "Base path of the warm storage repository",
        required: true
      }
    ), CredentialFields && /* @__PURE__ */ React.createElement(CredentialFields, { type })))), /* @__PURE__ */ React.createElement(Modal.Footer, null, definition ? /* @__PURE__ */ React.createElement(
      ModalSubmit,
      {
        submitButtonText: "Create",
        submitLoadingText: "Verifying credentials...",
        onCancel: hideModal,
        disabledSubmit: isValidating || !isValid,
        isSubmitting,
        isAsyncSubmit: true
      }
    ) : /* @__PURE__ */ React.createElement(
      ModalSubmit,
      {
        submitButtonText: "Create",
        submitLoadingText: "Creating...",
        onCancel: hideModal,
        disabledSubmit: isValidating || !isValid,
        isSubmitting
      }
    )))
  );
};
export default CloudStorageRepositoryModalForm;
